import {
  SET_USERS,
  SET_IS_LOADING_USERS,
  SET_USER,
  SET_IS_LOADING_USER,
  SET_USER_PREFERENCES,
  UPDATE_USER_STATUS,
  UPDATE_USER,
  SWITCH_USER_VIEW,
} from "redux/constants/portal";

const initialState = {
  users: [],
  isLoadingUsers: false,
  user: {},
  isLoadingUser: false,
  userPreferences: false,
  userView: "list",
};

const users = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_USERS:
      return {
        ...state,
        users: payload,
      };
    case SET_IS_LOADING_USERS:
      return {
        ...state,
        isLoadingUsers: payload,
      };
    case SET_USER:
      return {
        ...state,
        user: payload,
      };
    case SET_IS_LOADING_USER:
      return {
        ...state,
        isLoadingUser: payload,
      };
    case SET_USER_PREFERENCES:
      return {
        ...state,
        userPreferences: payload,
      };
    case UPDATE_USER_STATUS:
      return {
        ...state,
        users: state.users.map((user) =>
          user.auth0_id === payload.auth0_id
            ? {
                ...user,
                status: payload.status,
              }
            : user
        ),
      };
    case UPDATE_USER:
      return {
        ...state,
        users: state.users.map((user) =>
          user.auth0_id === payload.auth0_id
            ? {
                ...user,
                ...payload,
              }
            : user
        ),
      };
    case SWITCH_USER_VIEW:
      return {
        ...state,
        userView: payload,
      };
  }
  return state;
};

export default users;
